module.exports = __webpack_public_path__ + "static/media/29BDOS17.fbbc4a54.jpg";